import { documentationActions } from '../../actions/constant';

const {
  APPROVE_RECHECK_DISCHARGE_SUCCESS,
  APPROVE_RECHECK_DISCHARGE_FAILURE,
  APPROVE_RECHECK_DISCHARGE_LOADING,
  APPROVE_RECHECK_DISCHARGE_RESET,
} = documentationActions;

const initialState: object = {
  response: null,
  loading: false,
  isSuccess: false,
};

export const approveRecheckDischargeReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case APPROVE_RECHECK_DISCHARGE_SUCCESS: {
      return {
        ...state,
        response: action.payload?.data,
        loading: false,
        isSuccess: true,
      };
    }

    case APPROVE_RECHECK_DISCHARGE_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isSuccess: false,
      };

    case APPROVE_RECHECK_DISCHARGE_LOADING:
      return {
        ...state,
        loading: true,
      };

    case APPROVE_RECHECK_DISCHARGE_RESET:
      return initialState;

    default:
      return state;
  }
};
